export const DRAFTJS_BLOCK_KEY = 'DRAFTJS_BLOCK_KEY';